import React, {useState} from "react";
import {TextObservable} from "../../../stores/observables/textObservable";
import {observer} from "mobx-react-lite";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import classnames from "classnames";
import EditField from "../../molecules/editField/editField";
import "./richTextEditor.sass";
import {useTranslation} from "react-i18next";
import {EditorConfig} from "@ckeditor/ckeditor5-core";
import ClassicEditor from "@ckeditor/ckeditor5-build-ryman";

export interface IRichTextEditorProps {
  disabled?: boolean;
  text: TextObservable;
  validationMessage?: string;
  label?: string;
  placeholder?: string;
}

const RichTextEditor: React.FC<IRichTextEditorProps> = ({
  disabled,
  text,
  validationMessage,
  label,
  placeholder
}: IRichTextEditorProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const {t} = useTranslation();

  const errorMessage = text.isLengthValid()
    ? validationMessage
    : t("controls.characterLimitExceeded");

  const editorConfig: EditorConfig = {
    placeholder: placeholder,
    toolbar: [
      "heading",
      "|",
      "bold",
      "italic",
      "|",
      "numberedList",
      "bulletedList",
      "|",
      "link"
    ],
    heading: {
      options: [
        {model: "paragraph", title: "Body", class: "ck-heading_paragraph"},
        {
          model: "heading1",
          view: "h2",
          title: "Heading",
          class: "ck-heading_heading1"
        },
        {
          model: "heading2",
          view: "h3",
          title: "Subheading",
          class: "ck-heading_heading2"
        }
      ]
    },
    removePlugins: ["LinkEditor"]
  };

  return (
    <div className="rich-text-editor">
      <EditField label={label} isRequired={text.validate != null && !disabled}>
        <>
          <div
            className={classnames("editor", {
              focused: isFocused,
              disabled,
              "is-invalid": !text.isValid
            })}
          >
            <CKEditor
              disabled={disabled}
              editor={ClassicEditor}
              config={editorConfig}
              data={text.text}
              onChange={(event, editor) => {
                const data = editor.data.get();
                text.setText(data);
              }}
              onBlur={() => {
                setIsFocused(false);
              }}
              onFocus={() => {
                setIsFocused(true);
              }}
              onError={() => {}}
            />
          </div>
          {!disabled && (
            <div className="info">
              {!text.isValid && <label>{errorMessage}</label>}
              <div
                className={classnames("word-count", {
                  "is-invalid": !text.isValid
                })}
              >{`${text.text.length}/${text.maxLength}`}</div>
            </div>
          )}
        </>
      </EditField>
    </div>
  );
};

export default observer(RichTextEditor);
